export default "__VITE_ASSET__OufLmdZP__"